// Nav.js
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import '../styles/Nav.css';
import { Link } from 'react-router-dom';

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="logo-text">STOCKKHATA</Link>
        </div>

        <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" aria-label="Home">Home</Link>
          <Link to="/calculators" aria-label="Financial Calculators">Calculators</Link>
          <Link to="/login" aria-label="Login">Login</Link>
          <Link to="/signup" aria-label="Signup">Signup</Link>
          {/* <Link to="/threads-blogs" aria-label="Community Thread/Blogs">Thougts</Link> */}
        </div>
      </div>
    </nav>
  );
};

export default Nav;